import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle'
import { useTranslation } from 'react-i18next';
import CustomPressable from '../../components/customPressable/customPressable';
import HeaderWithBack from '../../components/Header/headerWithBack';

const ActivititiesConfirmation = (props) => {
    const { handleNext } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();

    return (
        <View style={getStyles(['widgetRootContainer', 'activitiesConfirmationRootContainer'])} id='activitiesConfirmationRootContainer'>
            <HeaderWithBack />
            
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'activitiesConfirmBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='activitiesConfirmationMainContainer'
            >
                <View style={getStyles(['widgetmainContainerChildContainer', 'activitiesCreateBookingHeaderContainer'])} id='activitiesCreateBookingHeaderContainer'>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'activitiesCreateBookingHeaderTitle'])} id='activitiesCreateBookingHeaderTitle'>
                            You're Confirmed
                        </Text>
                        
                        <Text style={getStyles(['activitiesConfirmationBookingHeaderDescription'])} id='activitiesConfirmationBookingHeaderDescription'>
                            Thank you for your booking request. Please reach out to our team if you have any questions or special requests. We are looking forward to having you!
                        </Text>
                </View>

            </ScrollView>


            <View id='activitiesBookingNextButtonContainer' style={getStyles(['activitiesBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={() => handleNext && handleNext()} id="primaryBtn">
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t('way_activity.close')}
                    </Text>
                </CustomPressable>
            </View>

        </View>
    )
}

export default ActivititiesConfirmation
